<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Active Integrations'"
      
      [customBack]="'integration/all'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
    @if (loaded) {
      <tidy-active-integrations
        [webhooks]="dialogParams?.webhooks"
        [remoteAccessAddresses]="dialogParams?.remoteAccessAddresses"
        [addresses]="dialogParams?.addresses"
        [activeIntegrations]="dialogParams?.activeIntegrations"
        [page]="'active-integrations'" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
